<div class="relative">
    <!-- Profile Avatar -->
    <div
        #profileBtn
        class="flex items-center justify-center cursor-pointer hover:rounded-[62.4375rem] hover:bg-[#F6F7FF] p-2 min-w-[2.5rem]"
        [matMenuTriggerFor]="dropdownMenu">
        <img src="/assets/images/auth/user-avatar-grey-icon.svg" alt="Profile icon" class="h-5 w-5 object-cover" />
    </div>

    <!-- Dropdown Menu -->
    <mat-menu #dropdownMenu="matMenu">
        <!-- Name & Email -->
        <div class="flex items-center space-x-2 px-4 py-3 border-b border-[#E7EAF0]" (click)="$event.stopPropagation()">
            <img class="w-auto h-4" alt="UserAvatar" src="/assets/images/auth/user-avatar-icon.svg" />
            <div class="flex-1 min-w-0">
                <p class="text-[0.875rem] text-[#0A0A0A] font-medium truncate">
                    {{ loginUser?.name }}
                </p>
                <p class="text-[0.875rem] text-[#717182] truncate">
                    {{ loginUser?.email }}
                </p>
            </div>
        </div>

        <!-- Sign Out -->
        <div class="flex items-center space-x-2 px-4 py-3 cursor-pointer" (click)="signOut()">
            <img class="w-auto h-4" alt="Signout" src="/assets/images/auth/sign-out-icon.svg" />
            <p class="text-[0.875rem] text-[#D4183D]">Sign out</p>
        </div>
    </mat-menu>
</div>
